import { render, staticRenderFns } from "./searchBill_wx.vue?vue&type=template&id=34a1b2ba&scoped=true"
import script from "./searchBill_wx.vue?vue&type=script&lang=js"
export * from "./searchBill_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a1b2ba",
  null
  
)

export default component.exports